import classnames from 'classnames'
import {
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_WAITING,
    SUBSCRIPTION_STATUS_CANCELLED,
} from 'dashboard-subscriptions/constants'
import styles from './styles.module.scss'

const HeaderActive = () => (
    <div className={styles.tableHeader}>
        <div className={styles.subscriptionId}>
            <T>dashboard.label.subscription</T>
        </div>
        <div className={styles.productName}>
            <T>dashboard.label.product</T>
        </div>
        <div className={styles.date}>
            <T>dashboard.label.start.date</T>
        </div>
        <div className={classnames(styles.location, styles.noBorder)}>
            <T>dashboard.label.location</T>
        </div>
        <div className={styles.balance}>
            <T>dashboard.label.balance.due</T>
        </div>
    </div>
)

const HeaderHistory = () => (
    <div className={styles.tableHeader}>
        <div className={styles.subscriptionId}>
            <T>dashboard.label.subscription</T>
        </div>
        <div className={styles.productName}>
            <T>dashboard.label.product</T>
        </div>
        <div className={styles.date}>
            <T>dashboard.label.start.date</T>
        </div>
        <div className={classnames(styles.location, styles.noBorder)}>
            <T>dashboard.label.location</T>
        </div>
        <div className={styles.balance}>
            <T>dashboard.label.balance.due</T>
        </div>
    </div>
)

const HeaderWaitList = () => (
    <div className={styles.tableHeader}>
        <div className={classnames(styles.productName, styles.productNameFirstCol)}>
            <T>dashboard.label.product</T>
        </div>
        <div className={styles.date}>
            <T>dashboard.label.created.date</T>
        </div>
        <div className={styles.location}>
            <T>dashboard.label.location</T>
        </div>
        <div className={styles.state}>
            <T>dashboard.label.status</T>
        </div>
        <div className={styles.action} />
    </div>
)

const getHeader = status => {
    switch (status) {
        case SUBSCRIPTION_STATUS_CANCELLED:
            return <HeaderHistory />
        case SUBSCRIPTION_STATUS_ACTIVE:
            return <HeaderActive />
        case SUBSCRIPTION_STATUS_WAITING:
            return <HeaderWaitList />
    }
}

export default getHeader
